import moment from 'moment-timezone';

export function dentalDateToUtc(value: string, timeZone: string): string {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || !moment.utc(value, 'YYYY-MM-DD', true).isValid())
        throw new Error('Spreadsheet dates must be real dates in YYYY-MM-DD format.');
    if (!moment.tz.zone(timeZone)) throw new Error('Configure a valid application time zone before importing dates.');
    const local = moment.tz(value, 'YYYY-MM-DD', true, timeZone);
    if (local.format('YYYY-MM-DD HH:mm:ss') !== `${value} 00:00:00`)
        throw new Error(`Midnight on ${value} does not exist in ${timeZone}. Check the source date and application time zone.`);
    const zone = moment.tz.zone(timeZone)!;
    const wall = moment.utc(value, 'YYYY-MM-DD', true).valueOf();
    const offsets = new Set([zone.utcOffset(local.valueOf() - 86400000), zone.utcOffset(local.valueOf()), zone.utcOffset(local.valueOf() + 86400000)]);
    const matches = Array.from(offsets).filter(offset => moment.tz(wall + offset * 60000, timeZone).format('YYYY-MM-DD HH:mm:ss') === `${value} 00:00:00`);
    if (matches.length !== 1) throw new Error(`Midnight on ${value} is ambiguous in ${timeZone}. Check the source date and application time zone.`);
    return local.toISOString().replace('.000Z', 'Z');
}

export function dentalRowDatesToUtc(values: Record<string, string>, timeZone: string): Record<string, string> {
    return Object.keys(values).reduce((row, key) => {
        row[key] = /Date$/.test(key) && values[key] ? dentalDateToUtc(values[key], timeZone) : values[key];
        return row;
    }, {} as Record<string, string>);
}
